import { Component, Inject, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { RecursoService } from 'src/app/services/recurso.service'
import { UnespCoreEnvironment, UnespCoreMessageService } from 'src/libs/unesp-core'
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../confirm-dialog/confirm-dialog.component'
import { NotaValidator } from 'src/app/utils/nota-validator'
import { ArquivoViewerAvaliacaoComponent } from '../../comissao-julgadora/arquivo-viewer-avaliacao/arquivo-viewer-avaliacao.component'

@Component({
  selector: 'app-recurso-notas',
  templateUrl: './recurso-notas.component.html',
  styleUrls: ['./recurso-notas.component.scss']
})
export class RecursoNotasComponent implements OnInit {
  recursoId!: number
  resumoNotas: any
  loading = true
  private baseUrl: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private recursoService: RecursoService,
    private messageService: UnespCoreMessageService,
    private dialog: MatDialog,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  ngOnInit(): void {
    this.recursoId = Number(this.route.snapshot.paramMap.get('id'))
    this.carregarNotas()
  }

  carregarNotas(): void {
    this.loading = true
    this.recursoService.obterNotasInscricaoRecurso(this.recursoId).subscribe({
      next: (data) => {
        this.resumoNotas = data
        this.loading = false
      },
      error: (error) => {
        this.messageService.showMessageError(error.error?.message || 'Erro ao carregar notas')
        this.loading = false
      }
    })
  }

  voltar(): void {
    this.router.navigate(['/comissao/recursos-pendentes'])
  }

  getExaminadores(): any[] {
    return this.resumoNotas.notasPorExaminador || []
  }

  getProvas(): string[] {
    if (!this.resumoNotas.notasPorExaminador?.length) return []
    const provasSet = new Set<string>()
    this.resumoNotas.notasPorExaminador.forEach((examinador: any) => {
      Object.keys(examinador.notas).forEach(prova => provasSet.add(prova))
    })
    return Array.from(provasSet)
  }

  getNota(examinador: any, prova: string): any {
    return examinador.notas?.[prova] || '-'
  }

  getMediaExaminador(examinador: any): any {
    const notas = Object.values(examinador.notas).filter((n: any) => n != null)
    if (notas.length === 0) return '-'
    const soma = notas.reduce((acc: number, nota: any) => acc + Number(nota), 0)
    return (soma / notas.length).toFixed(2)
  }

  getDisplayedColumns(): string[] {
    return ['examinador', ...this.getProvas()]
  }

  getMatricula(examinador: any): string {
    return examinador.matricula || ''
  }

  onNotaChange(examinador: any, prova: string, event: any): void {
    const nota = examinador.notas[prova]
    if (nota !== null && nota !== undefined && nota !== '') {
      const validation = NotaValidator.isNotaValid(Number(nota))
      if (!validation.valid) {
        this.messageService.showMessageError(validation.message!)
        examinador.notas[prova] = null
        event.target.value = ''
      }
    }
  }

  salvarNotas(): void {
    const confirmDialog = new ConfirmDialogModel(
      'Confirmar retificação de notas',
      'As notas serão alteradas e a classificação será recalculada. Deseja continuar?'
    )

    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: confirmDialog })

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const notasParaEnviar = this.resumoNotas.notasPorExaminador.flatMap((examinador: any) =>
          Object.entries(examinador.notas).map(([tipoProva, nota]) => ({
            comissaoJulgadoraId: examinador.comissaoId,
            tipoProva,
            nota
          }))
        )

        this.recursoService.atualizarNotasRecurso(this.recursoId, notasParaEnviar).subscribe({
          next: (response: any) => {
            this.messageService.showMessageSuccess('Notas atualizadas com sucesso')
            if (response?.todosRecursosConcluidos) {
              this.router.navigate(['/comissao-julgadora/resultado/classificacao', this.resumoNotas.concursoId])
            } else {
              this.router.navigate(['/comissao/recursos-pendentes'])
            }
          },
          error: (error) => {
            this.messageService.showMessageError(error.error?.message || 'Erro ao atualizar notas')
          }
        })
      }
    })
  }

  visualizarDocumentosComplementares(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/comissao-julgadora/visualizar-complementos', this.resumoNotas.inscricaoId])
    );
    window.open(url, '_blank');
  }

  visualizarProvaEscrita(): void {
    const url = `${this.baseUrl}/comissao-prova/inscricaodocumento/${this.resumoNotas.idArquivoProva}/${this.resumoNotas.arquivoProva}`
    this.abrirViewer('Prova Escrita', url)
  }

  visualizarAnexo(): void {
    const url = `${this.baseUrl}/comissao/recurso/${this.recursoId}/anexo/${this.resumoNotas.anexoRecurso}`
    this.abrirViewer('Anexo do Recurso', url)
  }

  private abrirViewer(titulo: string, url: string): void {
    this.dialog.open(ArquivoViewerAvaliacaoComponent, {
      data: { tituloDoArquivo: titulo, urlDoArquivo: url },
      width: '98vw', height: '96vh', maxWidth: '100vw', panelClass: 'fullheight-dialog'
    })
  }
}
